import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Component } from "react";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import BookingProvider from "@/components/BookingProvider";
import { initLenis, scrollToTop } from "@/lib/scroll";
import { initTracking, trackPageView } from "@/tracking/analytics";
import "@/App.css";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen bg-ink-900 flex items-center justify-center px-6">
                    <div className="text-center">
                        <p className="font-serif text-3xl text-white mb-3">
                            Something went wrong.
                        </p>
                        <p className="text-zinc-400">
                            Please refresh the page and try again.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function RouteScrollTop() {
    const { pathname } = useLocation();
    const firstLoad = useRef(true);
    useEffect(() => {
        scrollToTop();
        // Initial page_view is automatic via the gtag config; track SPA navigations.
        if (firstLoad.current) {
            firstLoad.current = false;
            return;
        }
        trackPageView(pathname);
    }, [pathname]);
    return null;
}

export default function App() {
    useEffect(() => {
        initLenis();
        initTracking();
    }, []);
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <BookingProvider>
                    <RouteScrollTop />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/thank-you" element={<ThankYou />} />
                    </Routes>
                </BookingProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}
